import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useEventOutcomesCache } from './cache'
import { type EventOutcomeRemoveInput, type EventOutcomeRemoveSuccess, toResponseError } from '@terros/common'

export function useRemoveEventOutcome(): RemoveHookResponse<EventOutcomeRemoveInput> {
  const { removeItem } = useEventOutcomesCache()

  const mutation = useTantalimMutation<EventOutcomeRemoveInput, EventOutcomeRemoveSuccess>({
    url: '/calendar/outcome/remove',
  })

  async function remove(input: EventOutcomeRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      removeItem(input.outcomeId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
